class Product {
  constructor() {
    ((this.acc = []),
      (this.container = document.querySelector(".m-main-product")),
      MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState(),
      MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState(),
      this.addRecentViewedProduct(),
      addEventDelegate({
        context: this.container,
        selector: (window.__minimog_review_selector || "") + ".m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview",
        handler: (e) => {
          const t = e.target.closest(".m-product-collapsible").dataset.index;
          setTimeout(() => {
            this.acc[Number(t)].setContentHeight();
          }, 300);
        },
        capture: !0,
      }));
  }
  addRecentViewedProduct() {
    const e = getCookie("m-recent-viewed-products");
    let t = e ? JSON.parse(e) : [];
    -1 === t.indexOf(MinimogSettings.productHandle) && (t.unshift(MinimogSettings.productHandle), (t = t.slice(0, 20)), setCookie("m-recent-viewed-products", JSON.stringify(t)));
  }
}

if (document.querySelector(".benifit_wrapper .images_container .swiper-container") != null) {
  const swiper = new Swiper(".benifit_wrapper .images_container .swiper-container", {
    loop: false,
    slidesPerView: 1,
    allowTouchMove: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  document.querySelectorAll(".tab_wrapper .tab").forEach(function (tab) {
    tab.addEventListener("click", function () {
      var getIndex = this.getAttribute("data-index");
      document.querySelectorAll(".tab_wrapper .tab").forEach(function (tab) {
        tab.classList.remove("active");
      });
      this.classList.add("active");
      swiper.slideTo(getIndex, 500, false);
    });
  });
  swiper.on("slideChange", function () {
    document.querySelectorAll(".tab_wrapper .tab").forEach(function (tab) {
      tab.classList.remove("active");
    });
    document.querySelector(`.tab_wrapper .tab[data-index="${swiper.realIndex}"]`).classList.add("active");
  });
}

const addToCartBtn = document.querySelector(".m-product-form .m-add-to-cart"); // Main button
const stickyCartBtn = document.querySelector(".sticky-add-to-cart"); // Sticky button

if (addToCartBtn && stickyCartBtn) {
  window.addEventListener("scroll", function () {
    const rect = addToCartBtn.getBoundingClientRect();

    if (rect.top <= 0) {
      stickyCartBtn.classList.add("show");
    } else {
      stickyCartBtn.classList.remove("show");
    }
  });
}
const stickyCartButton = document.querySelector(".sticky-add-to-cart .m-button");
const productInfo = document.querySelector("#top") || document.querySelector(".m-main-product .m-main-product--info");

if (stickyCartButton && productInfo) {
  stickyCartButton.addEventListener("click", () => {
    const offset = 10; // Adjust this value to scroll a little below the section
    const topPosition = productInfo.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({
      top: topPosition,
      behavior: "smooth",
    });
    // addToCartBtn.click();
  });
}
